// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* consultaClienteCompact.css: estilos compactos y pequeños para la página de Consulta de Cliente */

.consulta-cliente-container {
    /* Reduce el ancho y márgenes para que se vea más pequeño en pantalla */
    max-width: 600px;
    margin: 20px auto;
    background-color: var(--sn-superficie);
    padding: 20px;
    border-radius: 8px;
    /* Box shadow más discreto */
    box-shadow: var(--sn-sombra);
    /* Fuente un poco más pequeña para todo el contenedor */
    font-size: 0.9rem;
    line-height: 1.4;
    color: var(--sn-texto);
    font-family: 'Montserrat', sans-serif;
  }

  /* Encabezados más pequeños */
  .consulta-cliente-container h1 {
    font-size: 1.4rem;
    margin-bottom: 10px;
    text-align: center;
  }
  .consulta-cliente-container h2 {
    font-size: 1.2rem;
    margin-bottom: 10px;
    text-align: center;
  }

  /* Espaciado reducido */
  .consulta-cliente-container .mt-4 {
    margin-top: 1rem !important;
  }
  .consulta-cliente-container .mb-4 {
    margin-bottom: 1rem !important;
  }
  .consulta-cliente-container .mb-3 {
    margin-bottom: 0.75rem !important;
  }

  /* Ajuste de formularios y controles */
  .consulta-cliente-container .form-control {
    padding: 8px 12px;
    font-size: 0.9rem;
    border-radius: 4px;
  }

  /* Botones más compactos */
  .consulta-cliente-container .btn {
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: 500;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.3s ease, transform 0.3s ease;
    font-size: 0.85rem;
  }

  .consulta-cliente-container .btn-primary {
    background-color: var(--sn-accion);
    color: var(--sn-accion-texto);
  }

  .consulta-cliente-container .btn-info {
    background-color: var(--sn-info);
    color: var(--sn-texto-invertido);
  }

  .consulta-cliente-container .btn-secondary {
    background-color: var(--sn-texto-3);
    color: var(--sn-texto-invertido);
  }

  /* Botón de Menú (circular) */
  .consulta-cliente-container .circle-container {
    margin-bottom: 15px;
  }

  .consulta-cliente-container .circle-btn {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
    border-radius: 50%;
  }

  .consulta-cliente-container .circle-text {
    font-size: 0.95rem;
  }

  /* Tablas: más compactas */
  .consulta-cliente-container .table {
    margin-top: 15px;
    font-size: 0.9rem;
  }

  .consulta-cliente-container .table th,
  .consulta-cliente-container .table td {
    padding: 8px 10px;
  }

  /* Modales (si usas modales en esta página) */
  .consulta-cliente-container .modal-header {
    padding: 10px;
  }

  .consulta-cliente-container .modal-body,
  .consulta-cliente-container .modal-footer {
    padding: 10px;
  }

  /* Alertas y spinner */
  .consulta-cliente-container .alert {
    padding: 10px;
    border-radius: 4px;
    font-size: 0.9rem;
    text-align: center;
  }

  .consulta-cliente-container .spinner-border {
    width: 2.5rem;
    height: 2.5rem;
    margin: 15px auto;
    display: block;
  }
`, "",{"version":3,"sources":["webpack://./src/pages/1_0_consultaCliente.css"],"names":[],"mappings":"AAAA,mGAAmG;;AAEnG;IACI,uEAAuE;IACvE,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,4BAA4B;IAC5B,uDAAuD;IACvD,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,uBAAuB;EACvB;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,qDAAqD;IACrD,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,gCAAgC;EAClC;;EAEA;IACE,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,6CAA6C;EAC7C;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB","sourcesContent":["/* consultaClienteCompact.css: estilos compactos y pequeños para la página de Consulta de Cliente */\n\n.consulta-cliente-container {\n    /* Reduce el ancho y márgenes para que se vea más pequeño en pantalla */\n    max-width: 600px;\n    margin: 20px auto;\n    background-color: var(--sn-superficie);\n    padding: 20px;\n    border-radius: 8px;\n    /* Box shadow más discreto */\n    box-shadow: var(--sn-sombra);\n    /* Fuente un poco más pequeña para todo el contenedor */\n    font-size: 0.9rem;\n    line-height: 1.4;\n    color: var(--sn-texto);\n    font-family: 'Montserrat', sans-serif;\n  }\n\n  /* Encabezados más pequeños */\n  .consulta-cliente-container h1 {\n    font-size: 1.4rem;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n  .consulta-cliente-container h2 {\n    font-size: 1.2rem;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  /* Espaciado reducido */\n  .consulta-cliente-container .mt-4 {\n    margin-top: 1rem !important;\n  }\n  .consulta-cliente-container .mb-4 {\n    margin-bottom: 1rem !important;\n  }\n  .consulta-cliente-container .mb-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  /* Ajuste de formularios y controles */\n  .consulta-cliente-container .form-control {\n    padding: 8px 12px;\n    font-size: 0.9rem;\n    border-radius: 4px;\n  }\n\n  /* Botones más compactos */\n  .consulta-cliente-container .btn {\n    padding: 8px 16px;\n    border-radius: 4px;\n    font-weight: 500;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: background 0.3s ease, transform 0.3s ease;\n    font-size: 0.85rem;\n  }\n\n  .consulta-cliente-container .btn-primary {\n    background-color: var(--sn-accion);\n    color: var(--sn-accion-texto);\n  }\n\n  .consulta-cliente-container .btn-info {\n    background-color: var(--sn-info);\n    color: var(--sn-texto-invertido);\n  }\n\n  .consulta-cliente-container .btn-secondary {\n    background-color: var(--sn-texto-3);\n    color: var(--sn-texto-invertido);\n  }\n\n  /* Botón de Menú (circular) */\n  .consulta-cliente-container .circle-container {\n    margin-bottom: 15px;\n  }\n\n  .consulta-cliente-container .circle-btn {\n    width: 50px;\n    height: 50px;\n    font-size: 1.5rem;\n    border-radius: 50%;\n  }\n\n  .consulta-cliente-container .circle-text {\n    font-size: 0.95rem;\n  }\n\n  /* Tablas: más compactas */\n  .consulta-cliente-container .table {\n    margin-top: 15px;\n    font-size: 0.9rem;\n  }\n\n  .consulta-cliente-container .table th,\n  .consulta-cliente-container .table td {\n    padding: 8px 10px;\n  }\n\n  /* Modales (si usas modales en esta página) */\n  .consulta-cliente-container .modal-header {\n    padding: 10px;\n  }\n\n  .consulta-cliente-container .modal-body,\n  .consulta-cliente-container .modal-footer {\n    padding: 10px;\n  }\n\n  /* Alertas y spinner */\n  .consulta-cliente-container .alert {\n    padding: 10px;\n    border-radius: 4px;\n    font-size: 0.9rem;\n    text-align: center;\n  }\n\n  .consulta-cliente-container .spinner-border {\n    width: 2.5rem;\n    height: 2.5rem;\n    margin: 15px auto;\n    display: block;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
